import type { V1StockMessageKey } from './v1-stock.en'

/** V1 godown stock lookup, red-tie bags, replace a torn bag strings (Hindi), spread into hi.ts. The type forces every key in v1-stock.en.ts. */
export const v1StockHi: Record<V1StockMessageKey, string> = {
  // क्या कहाँ है
  'store.v1.stock.title': 'क्या कहाँ है',
  'store.v1.stock.hint': '**जगह का लेबल** या **बोरी का टैग** स्कैन करें',
  'store.v1.stock.scan': 'जगह या बोरी स्कैन करें',
  'store.v1.stock.orPick': 'या जगह चुनें',
  'store.v1.stock.onRoad': 'रास्ते में गाड़ियाँ ({count})',
  'store.v1.stock.another': 'दूसरी देखें',
  'store.v1.stock.up': 'ऊपर जाएँ',
  'store.v1.stock.count': 'यहाँ गिनें',
  'store.v1.stock.bagsWord': 'बोरी',
  'store.v1.stock.bagsN': '{count} बोरी',
  'store.v1.stock.kg': '{kg} किलो',
  'store.v1.stock.days': '{count} दिन से यहाँ',
  'store.v1.stock.ready': 'भेजने को तैयार',
  'store.v1.stock.held': 'ऑफ़िस ने रोकी',
  'store.v1.stock.noForm': 'गोदाम का फ़ॉर्म नहीं भरा: ये बोरियाँ अभी नहीं भेज सकते',
  'store.v1.stock.formEnds': 'गोदाम का फ़ॉर्म {count} दिन में खत्म: फिर से भरें',
  'store.v1.stock.lotsHere': 'यहाँ के लॉट',
  'store.v1.stock.onDockTitle': 'उतरी हैं, अभी जगह पर नहीं',
  'store.v1.stock.dock': 'उतरी, जगह पर नहीं',
  'store.v1.stock.empty': 'यहाँ कोई बोरी नहीं',
  'store.v1.stock.flagHeld': 'ऑफ़िस ने रोकी',
  'store.v1.stock.flagRedTie': 'लाल टाई बाँधनी बाकी',
  'store.v1.stock.flagNotSent': 'अभी भेजा नहीं',
  'store.v1.stock.flagProblem': 'भेजने में दिक्कत',
  'store.v1.stock.lot': 'लॉट {lot}',
  'store.v1.stock.holdLot':
    'ऑफ़िस ने रोका है: बोरियाँ अपनी जगह रहेंगी और सुपरवाइज़र के कहने तक **भेज नहीं सकते**',
  'store.v1.stock.where': 'बोरियाँ कहाँ हैं',
  'store.v1.stock.missing': 'गायब',
  'store.v1.stock.onTrip': 'गाड़ी {vehicle} पर',
  'store.v1.stock.elsewhere': 'दूसरी जगह',
  'store.v1.stock.notHere':
    'यह टैग इस गोदाम की सूची में नहीं है। इंटरनेट मिलने पर सूची ताज़ा करें।',
  'store.v1.stock.roadTitle': 'रास्ते में गाड़ियाँ',
  'store.v1.stock.noRoad': 'कोई गाड़ी रास्ते में नहीं',
  'store.v1.stock.from': '{place} से आ रही',
  'store.v1.stock.to': '{place} जा रही',

  // लाल टाई वाली बोरियाँ
  'store.v1.redTie.title': 'लाल टाई वाली बोरियाँ',
  'store.v1.redTie.none': 'अभी किसी बोरी पर लाल टाई नहीं बाँधनी',
  'store.v1.redTie.need': '{count} बोरी पर लाल टाई बाँधनी है',
  'store.v1.redTie.tied': 'बँधी',
  'store.v1.redTie.how': 'बोरी पर **लाल टाई** बाँधें, फिर उसका टैग स्कैन करें',
  'store.v1.redTie.lot': '{lot} · {n}/{m} बँधी',
  'store.v1.redTie.newSacks': '{count} नई बोरी (सबूत नहीं)',
  'store.v1.redTie.notListed': 'इस बोरी पर लाल टाई नहीं बाँधनी',
  'store.v1.redTie.confirm': 'लाल टाई बाँध दी',
  'store.v1.redTie.doneTitle': 'लाल टाई बाँध दी',
  'store.v1.redTie.doneLine': '**{count}** बोरी साधारण माल में',
  'store.v1.redTie.moveNext': 'अब "बोरियाँ हटाएँ" से इन्हें **{bay}** में ले जाएँ',
  'store.v1.redTie.moveNextNoBay': 'अब "बोरियाँ हटाएँ" से इन्हें लाल टाई वाली जगह ले जाएँ',

  // फटी बोरी
  'store.v1.replace.title': 'फटी बोरी',
  'store.v1.replace.countFirst':
    'पहले उस **जगह की गिनती** करें जहाँ फटी बोरी है: उसका लेबल स्कैन करें',
  'store.v1.replace.asked': 'ऑफ़िस ने {ago} पहले कहा',
  'store.v1.replace.countEvery': 'इस जगह की **हर बोरी** का टैग स्कैन करें',
  'store.v1.replace.counted': 'गिनी',
  'store.v1.replace.lotLine': '{lot} · {n}/{m}',
  'store.v1.replace.short': '{count} बोरी कम',
  'store.v1.replace.nothingHere': 'सूची में इस जगह कोई बोरी नहीं',
  'store.v1.replace.notFromHere': '{count} टैग इस जगह के नहीं: {tags}',
  'store.v1.replace.countDone': 'गिनती हो गई, आगे',
  'store.v1.replace.countSaved': 'गिनती सेव हुई',
  'store.v1.replace.recent': 'पहले बदली बोरियाँ',
  'store.v1.replace.recentLine': 'टैग {old} → {new}',
  'store.v1.replace.lost': 'गायब',
  'store.v1.replace.statusPending': 'अभी भेजा नहीं',
  'store.v1.replace.statusReview': 'अलग रखी है: सुपरवाइज़र जाँचेंगे',
  'store.v1.replace.statusOrphan':
    'सबूत नहीं मिला: अब यह **साधारण** माल है। लाल टाई बाँधें, स्कैन करें और लाल टाई वाली जगह ले जाएँ।',
  'store.v1.replace.statusError': 'भेजने में दिक्कत: सिंक खोलें',
  'store.v1.replace.lotShort': '{lot}: {count} कम',
  'store.v1.replace.noShort': 'यहाँ कोई लॉट कम नहीं: नई बोरी **साधारण** माल होगी',
  'store.v1.replace.old': 'पुराना टैग',
  'store.v1.replace.oldNone': 'तभी, जब बोरी पर अभी भी लगा हो',
  'store.v1.replace.oldHint': 'फटी बोरी का **पुराना टैग** स्कैन करें',
  'store.v1.replace.callSupervisor': 'पुराना टैग गायब: **सुपरवाइज़र को फ़ोन** करें',
  'store.v1.replace.new': 'नया टैग',
  'store.v1.replace.newEmpty': 'अपने टैग रोल से',
  'store.v1.replace.newHint': 'अपने रोल का **नया टैग** स्कैन करें',
  'store.v1.replace.sack': 'नई बोरी',
  'store.v1.replace.sackWeight': 'बोरी का वज़न {kg} किलो',
  'store.v1.replace.weight': 'बोरी समेत वज़न',
  'store.v1.replace.weightEmpty': 'वज़न लिखें',
  'store.v1.replace.weightHint': 'नई बोरी काँटे पर रखें और **जो दिखे** वह लिखें',
  'store.v1.replace.weightSave': 'वज़न सेव करें',
  'store.v1.replace.kgUnit': 'किलो',
  'store.v1.replace.net': 'बोरी के बिना माल',
  'store.v1.replace.gateNet': 'गेट पर {kg} किलो था',
  'store.v1.replace.heavier': 'पुरानी बोरी से भारी: सुपरवाइज़र जाँचेंगे',
  'store.v1.replace.candidate': 'लॉट {lot} का टैग {tag} लगती है ({kg} किलो)',
  'store.v1.replace.noCandidate':
    'कोई एक बोरी नहीं मिलती ({count} हो सकती हैं): यह साधारण माल होगा',
  'store.v1.replace.photo': 'नई बोरी की फोटो',
  'store.v1.replace.photoEmpty': 'फोटो लें',
  'store.v1.replace.crop': 'कौन सी फ़सल?',
  'store.v1.replace.pick': 'नहीं चुना',
  'store.v1.replace.pickBtn': 'चुनें',
  'store.v1.replace.change': 'बदलें',
  'store.v1.replace.scan': 'स्कैन',
  'store.v1.replace.type': 'लिखें',
  'store.v1.replace.remove': 'हटाएँ',
  'store.v1.replace.cutOld': '**पुराना टैग काटकर** सुपरवाइज़र के लिए रखें',
  'store.v1.replace.waitNew': 'नया टैग स्कैन करें',
  'store.v1.replace.waitSack': 'बोरी चुनें',
  'store.v1.replace.waitWeight': 'वज़न लिखें',
  'store.v1.replace.waitPhoto': 'फोटो लें',
  'store.v1.replace.waitCrop': 'फ़सल चुनें',
  'store.v1.replace.confirm': 'बोरी बदलें',
  'store.v1.replace.doneTitle': 'बोरी बदल दी',
  'store.v1.replace.doneLine': 'नया टैग {tag}',
  'store.v1.replace.doneChip': 'सुपरवाइज़र के जाँचने तक नई बोरी यहीं **अलग रखी** रहेगी',
}
